import { connect } from 'react-redux';
import { currentClientId } from '../../../AdvWorkflow/AdvWorkflowSelector';
import { updateData } from '../../../AdvWorkflow/AdvWorkflowActions';
import {
  selectDistributionYears,
  selectIsDecumulationGoalValid,
} from '../../DecumulationWorkflow.selector';
import DistributionYearsView from './DistributionYearsView';

const mapStateToProps = (state, ownProps) => ({
  clientId: currentClientId(state, ownProps),
  distributionYears: selectDistributionYears(state, ownProps),
  doNotSave: !selectIsDecumulationGoalValid(state, ownProps),
});

const mapDispatchToProps = dispatch => ({
  store: workflowId => (data, clientId) => dispatch(updateData(data, workflowId, clientId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(DistributionYearsView);
